/**
 * Created by dushyantha on 7/12/16.
 */
(function () {
    'use strict';

    angular
        .module('crewSchedule')
        .config(config);

    function config($stateProvider) {
        $stateProvider
            .state('crewSchedule', {
                url: '/crew-schedule/:crewId?/:time?',
                params: {
                    crewId: null,
                    time  : null
                },
                views: {
                    'crewScheduleView': {
                        templateUrl: 'crew-schedule/views/crew-schedule.tpl.html',
                        controller: 'crewScheduleCtrl',
                        controllerAs: 'crewSchedule'
                    }
                }
            });
    }
}());
